import api from "./axios";

export const login = async (Mail, Password) => {
  const response = await api.post("/User/login", { Mail, Password });
  return response.data;
};

export const changePassword = async (UserId, CurrentPassword, NewPassword) => {
  const response = await api.post("/User/change-password", {
    UserId,
    CurrentPassword,
    NewPassword,
  });
  return response.data;
};
